<template>
  <div class="" id="app">
    <Nav />
    <main>
      <Home />
    </main>
  </div>
</template>

<script>
import Home from './components/Home.vue'
import Nav from './components/Nav.vue'


export default {
  name: 'App',
  components: {
    Home,
    Nav
  }
}

</script>

<style>
html {
  scroll-behavior: smooth;
}
h1, h2, h3, h4, h5, h6 {
  font-family: 'Cormorant Garamond', serif !important;
}

#app {
  font-family: monospace;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
